var exports = {
  "DD": "x936d19a0--95b14e--title",
  "Qs": "x936d19a0--95b14e--content",
  "AS": "x936d19a0--95b14e--item",
  "_8": "x936d19a0--95b14e--img",
  "T$": "x936d19a0--95b14e--item-title",
  "hf": "x936d19a0--95b14e--button-sticky",
};

module.exports = exports;
